export default "__VITE_PUBLIC_ASSET__c5762759__"